<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"

                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="10"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add Client Email</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Select Client:</span>
            </div>

                <ClientAutocomplete
          :key="companySearchComponentKey" 
            class="searchbox"
            :list="searchCompany"
            :searchOn="'company_or_registration_no'"
            @event-name="setSelectedClient"
          ></ClientAutocomplete>
        
          </div>
                    <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Select Elomark User:</span>
            </div>

                     <ElomarkUserAutocomplete
            :key="elomarkUserSearchComponentKey"
            class="searchbox"
            :list="searchElomarkUser"
            :searchOn="'elomark_user'"
            @event-name="setSelectedElomarkUser"
          ></ElomarkUserAutocomplete>
        
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>UserName:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="username"
                v-model="client_email.username"
                v-validate="'required'"
                data-vv-as="User Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('username')"
              >{{ errors.first("username") }}</span
            >
          </div>
                 <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Email:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="email"
                v-model="client_email.email"
                v-validate="'required|email'"
                data-vv-as="Email"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('email')"
              >{{ errors.first("email") }}</span
            >
          </div>
                 <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Password:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                type= "password"
                name="password"
                v-model="client_email.password"
                v-validate="'required'"
                data-vv-as="Password"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('password')"
              >{{ errors.first("password") }}</span
            >
          </div>
                      <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
            <v-select v-model="client_email.status" label='value' name="username"
            data-vv-as="Status"
  v-validate="'required'" :options="client_status"/>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('status')"
              >{{ errors.first("status") }}</span
            >
          </div>
           <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
             
            </div>
            <div class="vx-col sm:w-1/3 w-full">
            <vs-button
            @click="submitForm"
            >Submit</vs-button
          >
            </div>
            
          </div>
           
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import axios from "@/axios.js";
import defineAbilitiesFor from "@/config/abilities";
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import vSelect from "vue-select";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import ElomarkUserAutocomplete from "@/components/autocomplete/ElomarkUserAutocomplete.vue";
export default {
  data() {
    return {
      client_email : {
         client_id:null,
         user_id : null,
         username : null,
         email:null,
         password : null,
         status : {
        name:'Live',
        value: 'Live'
      }
      },
      client_status:[{
        name:'Live',
        value: 'Live'
      },
      {
        name:'Suspended',
        value: 'Suspended'
      },
      {
        name:'Closed',
        value: 'Closed'
      }],
      abilities : null,
elomarkUserSearchComponentKey:0,
    companySearchComponentKey:0,
    selected: [],
    log: [],
    clients: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    size_per_page: [10,20,50,100,500],
    per_page: 10,
    paginationAttr:{
      'page_no':1,
      'per_page':10
    }
    };
  },
  components: {
    "v-select": vSelect,
    ClientAutocomplete,
       ElomarkUserAutocomplete,
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleClientsManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientsManagement);
      moduleClientsManagement.isRegistered = true;
    }
     if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
  },
  watch: {
   
  },
  mounted() {},
  methods: {
        setSelectedElomarkUser() {
      var selectedElomarkUsers = moduleElomarkUserManagement.state.elomark_users.datas
      this.client_email.user_id = selectedElomarkUsers[0].id
    },
     searchElomarkUser(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/searchElomarkUser", inputValue)
        .then(response => {
          if (response) {
            let data = moduleElomarkUserManagement.state.elomark_user;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].first_name + " " + data[property].surname
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
        setSelectedClient(){
     let selected_client = moduleClientsManagement.state.clients.datas
     this.client_email.client_id = selected_client[0].id
          console.log(this.client_email.client_id)

      // console.log("Client" , this.clients)
    },
     searchCompany(inputValue) {
      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleClientsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        console.log(this.errors)
        if (result) {
          
          this.addClientEmail();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    addClientEmail() {
      this.$store
        .dispatch("clientsManagement/addClientEmail", this.client_email)
        .then(res => {
          if (res.data.status == "fail") {
            this.client_email = res.data.data;
          } else {
            this.$vs.notify({
              color: "success",
              title: "Client Email Added",
              text: "The client email was added successfully"
            });
            this.$router.push({ path: "/dashboard" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style>
.flat-pick {
  padding: 0.7rem;
  border-radius: 5px;
  font-size: 1rem;
  color: #626262;
  cursor: pointer;
}
</style>
<style scoped>
.removeButton {
  cursor: pointer;
}

.inputx {
  width: 50px;
}

.searchbox {
  width: 582px;
}
</style>
